<div class="bottom_border_container">
  <div class="flex_container">
    <div>
      <h2 class="banner_title">{{h2Content}}</h2>
    </div>

    <div class="description_text">
      <span class="arrow">&#10230;</span>
      <p [innerHTML]="paragraphTemplate"></p>
    </div>
  </div>
</div>